export const mutations = {
  SET_CHANGELOG_ENTRIES(state, entries) {
    state.records = entries;
  },

  SET_CHANGELOG_UI_FLAG(state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },

  SET_CHANGELOG_META(state, meta) {
    state.meta = meta;
  },

  SET_CHANGELOG_UNREAD_COUNT(state, count) {
    state.unreadCount = count;
  },
};
